import { inject, Injectable } from '@angular/core';
import { assert } from '@sama/js-core';
import { ObjectState } from '../../../cross-team-shared/annotation/shared/state/object-state';
import {
  assertDefined,
  strictValues,
} from '../../../cross-team-shared/misc-utils/strict-record';
import { isTextAttribute } from '../../../outputs/annotation/annotation-shared/utils/attribute-utils';
import { ObjectClassService } from '../../shared/misc-services/object-class.service';

@Injectable()
export class AnnotationsService {
  private readonly objectClassService = inject(ObjectClassService);

  getAnnotationName(annotation: ObjectState) {
    const attributes = this.objectClassService.getClassAttributes(
      annotation.class,
    );
    assertDefined(attributes);

    const nameAttribute = strictValues(attributes).find(
      (attribute) => isTextAttribute(attribute) && attribute.isReadOnly,
    );

    assert(nameAttribute, 'Annotation must have a name attribute');
    const name: string = annotation.tags[nameAttribute.name];
    return name;
  }
}
